import { render, staticRenderFns } from "./Bargainlist.vue?vue&type=template&id=639c9cac&scoped=true"
import script from "./Bargainlist.vue?vue&type=script&lang=js"
export * from "./Bargainlist.vue?vue&type=script&lang=js"
import style0 from "./Bargainlist.vue?vue&type=style&index=0&id=639c9cac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c9cac",
  null
  
)

export default component.exports